import { abreviaturas } from 'constantes';
import authService from 'auth/AuthService';

export class IO {
  // Url´s para sistema de logueo
  static BASE_URL_SERVICES = abreviaturas.DEFAULT_SERVICES;

  static BASE_TOKEN_KIOSCO = null;

  static BASE_TOKEN_KEYCLOACK = null;

  static BASE_TOKEN = null;

  static BASE_API_URL = process.env.REACT_APP_BASE_URL_API;

  static BASE_API_URL_NODE = process.env.REACT_APP_BASE_URL_API_URL_NODE;

  static BASE_API_URL_VERIFICAR_AUTH = process.env.REACT_APP_BASE_URL_API_VERIFICAR_AUTH;

  static BASE_API_URL_VERIFICAR_DOMINIO = process.env.REACT_APP_BASE_URL_API_VERIFICAR_DOMINIO;

  // Headers que se enviaran en la petición
  static configOptions(dataForm, method, headers, type) {
    let headersOption = {};
    if (headers) {
      headersOption = {
        Accept: abreviaturas.DEFAULT_ACCEPT,
        'Content-Type': abreviaturas.DEFAULT_CONTET_TYPE,
        appType: type || '',
        token: authService.getToken(),
      };
    }
    const queryHeader = {
      method: method || abreviaturas.DEFAULT_POST,
      mode: abreviaturas.DEFAULT_MODE,
      cache: abreviaturas.DEFAULT_CACHE,
      credentials: abreviaturas.DEFAULT_CREDENTIALS,
      body: (method !== abreviaturas.DEFAULT_GET) ? dataForm : null,
      headers: headersOption || {},
    };

    return queryHeader;
  }

  static fetchClientDomain(dataForm) {
    return new Promise((resolve, reject) => {
      fetch(`${this.BASE_API_URL_NODE}/login/fetch-client-conn?username=${dataForm}`, { method: 'GET' }).then((res) => {
        const data = res.text();
        data.then((resData) => {
          if (resData) {
            IO.BASE_API_URL = `${JSON.parse(resData).url}${this.BASE_URL_SERVICES}`;
          }
          resolve(resData);
        }).catch((e) => {
          reject(e);
        });
      });
    });
  }

  static fetchKCLoginToken(dataForm) {
    return new Promise((resolve, reject) => {
      fetch(`${this.BASE_API_URL_NODE}/login/authkeycloakcodeFirma`, {
        method: 'POST',
        body: JSON.stringify(dataForm),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => {
        const data = res.json();
        data.then((resData) => {
          resolve(resData);
        }).catch((e) => {
          reject(e);
        });
      });
    });
  }

  static loginLionClient(clientUrl, dataForm) {
    return new Promise((resolve, reject) => {
      fetch(clientUrl.concat('services/authentication'), {
        method: 'POST',
        body: JSON.stringify(dataForm),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => {
        const data = res.text();
        data.then((resData) => {
          if (resData) {
            IO.BASE_TOKEN = res.t;
          }
          resolve(resData);
        }).catch((e) => {
          reject(e);
        });
      });
    });
  }

  /**
   * @name verificarDominioAuth
   * @desc Función que consulta al API si un dominio esta matriculado para asignar
   * una nueva URL de autencticación
   * @param dataForm
   * @returns {Promise<unknown>}
   */
  static verificarDominioAuth(dataForm) {
    const query = this.configOptions(dataForm);

    return new Promise((resolve, reject) => {
      fetch(`${this.BASE_API_URL_VERIFICAR_AUTH}`, query).then((res) => {
        const data = res.text();
        data.then((resData) => {
          if (resData) {
            IO.BASE_API_URL = `${JSON.parse(resData).url}${this.BASE_URL_SERVICES}`;
          }
          resolve(resData);
        }).catch((e) => {
          reject(e);
        });
      });
    });
  }

  /**
   * @name verificarDominio
   * @desc Función que verifica el dominio al cual loguearse mediante LDAP
   * @param dataForm
   * @returns {Promise<unknown>}
   */
  static verificarDominio(dataForm) {
    const query = this.configOptions(dataForm);

    return new Promise((resolve, reject) => {
      fetch(`${this.BASE_API_URL_VERIFICAR_DOMINIO}`, query).then((res) => {
        const data = res.text();
        data.then((resData) => {
          if (resData) {
            IO.BASE_API_URL = `${resData}${this.BASE_URL_SERVICES}`;
          }
          resolve(resData);
        }).catch((e) => {
          reject(e);
        });
      });
    });
  }

  /**
   * @name login
   * @desc Funcion que realiza el login del aplicativo
   * @param data
   * @param type
   * @param method
   * @returns {Promise<unknown>}
   */
  static login(data, type, method) {
    return new Promise((resolve, reject) => {
      IO.apiFetch(data, type, method)
        .then((res) => {
          if (res.resultado === abreviaturas.STATUS_APROBADO) {
            if (type && type === abreviaturas.TYPE_TOKEN_AUTH && res.t) {
              IO.BASE_TOKEN = res.t;
            } else if (type && type === abreviaturas.TYPE_TOKEN_KIOSCO && res.t) {
              IO.BASE_TOKEN_KIOSCO = res.t;
            }
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch((e) => {
          reject(e);
        });
    });
  }

  /**
   * @name apiFetch
   * @desc Función que realiza las llamadas al api y retorna su respuesta
   * @param data
   * @param type
   * @param method
   * @returns {Promise<unknown>}
   */
  static apiFetch(data, type, method, text) {
    const dataOBJ = text ? data : JSON.stringify(data);
    const query = this.configOptions(dataOBJ, method, 'header', type);

    return new Promise((resolve, reject) => {
      fetch(`${this.BASE_API_URL}${type}`, query)
        // fetch(`https://pruplaneada2.heinsohn.com.co/NominaWEB/services/${type}`, query)
        // fetch(`http://10.36.124.53:8443/NominaWEB/services/${type}`, query)
        .then((resp) => {
          if (resp.status === abreviaturas.DEFAULT_HTTP_OK[0]
            || resp.status === abreviaturas.DEFAULT_HTTP_OK[1]) {
            resolve(resp);
          } else {
            JSON.stringify(resp);
            resolve(resp);
          }
        }).catch((err) => {
          reject(err);
        });
    });
  }
}
